import React from 'react'
import { FilosofiaWrapper } from '../style'

const Filosofia = () => {
  return (
    <FilosofiaWrapper className="container">
      <h4>Juntos, vamos mais longe.</h4>
      <p>
        Na Riber, acreditamos na força das conexões. Por isso, valorizamos cada
        <br />
        parceiro que caminha ao nosso lado.
      </p>
    </FilosofiaWrapper>
  )
}

export default Filosofia
